import { CollectionFunction, HI2Interface, HI3Interface } from 'data/collectionFunction/collectionFunction.types';

export const mockHi2INterfaces: HI2Interface[] = [
  {
    id: 'hi2Id1',
    name: 'IP:202.202.202.202 PORT:1111',
    transportType: 'TCP',
    options: [
      { key: 'version', value: '15.5' },
      { key: 'traceLevel', value: '0' },
      { key: 'state', value: 'INACTIVE' },
      { key: 'reqState', value: 'ACTIVE' },
      { key: 'comments', value: '' },
      { key: 'connectionType', value: 'PRIMARY' },
      { key: 'ifid', value: '1' },
      { key: 'dscp', value: '0' },
      { key: 'destPort', value: '1111' },
      { key: 'keepAliveFreq', value: '60' },
      { key: 'keepAliveRetries', value: '6' },
      { key: 'tpkt', value: 'Y' },
      { key: 'destIPAddr', value: '202.202.202.202' },
      { key: 'ownIPAddr', value: '0.0.0.0' },
      { key: 'cfid', value: 'CA-DOJBNE-33108' },
      { key: 'ownIPPort', value: '0' },
    ],
  },
  {
    id: 'hi2Id2',
    name: 'IP:100.100.100.100 PORT:2222',
    transportType: 'FTP',
    options: [
      { key: 'version', value: '15.5' },
      { key: 'traceLevel', value: '0' },
      { key: 'state', value: 'INACTIVE' },
      { key: 'reqState', value: 'ACTIVE' },
      { key: 'comments', value: '' },
      { key: 'connectionType', value: 'PRIMARY' },
      { key: 'ifid', value: '1' },
      { key: 'dscp', value: '0' },
      { key: 'destPort', value: '2222' },
      { key: 'keepAliveFreq', value: '60' },
      { key: 'keepAliveRetries', value: '6' },
      { key: 'tpkt', value: 'Y' },
      { key: 'destIPAddr', value: '100.100.100.100' },
      { key: 'ownIPAddr', value: '0.0.0.0' },
      { key: 'cfid', value: 'CA-DOJBNE-33108' },
      { key: 'ownIPPort', value: '0' },
    ],
  },
];

export const mockHi3Interfaces: HI3Interface[] = [
  {
    id: 'hi3Id1',
    name: 'IP:34.45.56.67 PORT:4545',
    transportType: 'TCP',
    options: [
      { key: 'comments', value: '' },
      { key: 'connectionType', value: 'PRIMARY' },
      { key: 'displayLabel', value: '' },
      { key: 'keepAliveFreq', value: '60' },
      { key: 'keepAliveRetries', value: '6' },
      { key: 'inactivityTimer', value: '0' },
      { key: 'ownIPAddr', value: '' },
      { key: 'ownIPPort', value: '' },
      { key: 'ifid', value: '1' },
      { key: 'cfid', value: 'CA-DOJBNE-33108' },
      { key: 'version', value: '15.5' },
      { key: 'dscp', value: '0' },
      { key: 'tpkt', value: 'N' },
      { key: 'destPort', value: '4545' },
      { key: 'destIPAddr', value: '34.45.56.67' },
      { key: 'useIpdu', value: 'N' },
    ],
  },
  {
    id: 'hi3Id2',
    name: 'IP:56.34.45.45 PORT:8978',
    transportType: 'FTP',
    options: [
      { key: 'filter', value: 'ALL' },
      { key: 'uri', value: '' },
      { key: 'transport', value: 'TCP' },
      { key: 'traceLevel', value: '1' },
      { key: 'state', value: 'INACTIVE' },
      { key: 'secinfoid', value: 'NONE' },
      { key: 'role', value: 'CLIENT' },
      { key: 'reqState', value: 'ACTIVE' },
      { key: 'appProtocol', value: '' },
      { key: 'countryCode', value: 'NONE' },
      { key: 'ifid', value: '2' },
      { key: 'cfid', value: 'CA-DOJBNE-ATIS' },
      { key: 'version', value: '2' },
      { key: 'dscp', value: '0' },
      { key: 'encryptKey', value: '*****' },
      { key: 'sshInfoId', value: '' },
      { key: 'encryptMethod', value: 'NONE' },
      { key: 'tpkt', value: 'N' },
      { key: 'destPort', value: '8978' },
      { key: 'destIPAddr', value: '56.34.45.45' },
    ],
  },
];

// eslint-disable-next-line import/prefer-default-export
export const mockCollectionFunctions: CollectionFunction[] = [
  {
    id: 'Q0EtRE9KQk5FLTEwMDA2',
    dxOwner: 'dxOwner',
    dxAccess: 'dxAccess',
    name: 'CA-DOJBNE-33108',
    bufferCC: false,
    cellTowerLocation: false,
    contact: {
      id: '',
      name: '',
    },
    cfGroup: { id: 'id1', name: 'CA-DOJBNE' },
    deliveryType: 'DSR',
    insideNat: false,
    type: 'GPRS',
    tag: 'CF-3GPP-33108',
    timeZone: 'America/Los_Angeles',
    country: 'US',
    stateName: '',
    city: '',
    hi2Interfaces: mockHi2INterfaces,
    hi3Interfaces: mockHi3Interfaces,
  }, {
    id: 'Q29va0NvdW50eS0xMDAz',
    dxOwner: 'dxOwner',
    dxAccess: 'dxAccess',
    name: 'CookCounty-33108',
    bufferCC: false,
    cellTowerLocation: false,
    contact: {
      id: '',
      name: '',
    },
    cfGroup: { id: 'id2', name: 'CookCounty' },
    deliveryType: 'DSR',
    country: 'US',
    stateName: '',
    city: '',
    insideNat: false,
    type: 'GPRS',
    tag: 'CF-3GPP-33108',
    timeZone: 'America/Los_Angeles',
    hi2Interfaces: mockHi2INterfaces,
    hi3Interfaces: mockHi3Interfaces,
  }, {
    id: 'Q29va0NvdW50eS0xMDAw',
    name: 'CookCounty-1000678',
    dxOwner: 'dxOwner',
    dxAccess: 'dxAccess',
    bufferCC: false,
    cellTowerLocation: false,
    contact: {
      id: '',
      name: '',
    },
    cfGroup: { id: 'id2', name: 'CookCounty' },
    deliveryType: 'DSR',
    country: 'US',
    stateName: '',
    city: '',
    insideNat: false,
    type: 'T1.678',
    tag: 'CF-ATIS-1000678',
    timeZone: 'America/Tijuana',
    hi2Interfaces: [...mockHi2INterfaces].reverse(),
    hi3Interfaces: [...mockHi3Interfaces].reverse(),
  },
  {
    id: 'Q29va0NvdW50eS0xMDY2',
    dxOwner: 'dxOwner',
    dxAccess: 'dxAccess',
    name: 'CookCounty-1066',
    bufferCC: false,
    cellTowerLocation: false,
    contact: { id: '', name: '' },
    cfGroup: { id: 'id2', name: 'CookCounty' },
    deliveryType: 'DSR',
    country: 'US',
    stateName: '',
    city: '',
    insideNat: true,
    type: 'TIA1066',
    tag: 'CF-TIA-1066',
    timeZone: 'America/Tijuana',
    hi2Interfaces: mockHi2INterfaces,
    hi3Interfaces: mockHi3Interfaces,
  },
  {
    id: 'Q0EtRE9KQk5FLVRJQTEw',
    dxOwner: 'dxOwner',
    dxAccess: 'dxAccess',
    name: 'CA-DOJBNE-TIA1072',
    bufferCC: false,
    cellTowerLocation: false,
    contact: { id: '', name: '' },
    cfGroup: { id: 'id3', name: 'CA-DOJBNE-TIA1072' },
    deliveryType: 'DSR',
    insideNat: true,
    type: 'TIA1072',
    tag: 'CF-TIA-1072',
    timeZone: 'America/Tijuana',
    country: 'US',
    stateName: '',
    city: '',
    hi2Interfaces: [...mockHi2INterfaces].reverse(),
    hi3Interfaces: [...mockHi3Interfaces].reverse(),
  },
  {
    id: 'Q0EtRE9KQk5FLTVHQ0Y',
    dxOwner: 'dxOwner',
    dxAccess: 'dxAccess',
    name: 'CA-DOJBNE-5GCF',
    bufferCC: false,
    cellTowerLocation: false,
    contact: { id: '', name: '' },
    cfGroup: { id: 'id4', name: 'CA-DOJBNE-5GCF' },
    deliveryType: 'DSR',
    insideNat: false,
    type: 'ETSIIP',
    tag: 'CF-ETSI-102232',
    timeZone: 'America/Tijuana',
    country: 'US',
    stateName: '',
    city: '',
    hi2Interfaces: mockHi2INterfaces,
    hi3Interfaces: mockHi3Interfaces,
  }, {
    id: 'Q29va0NvdW50eS0xMDAp',
    name: 'US Wireline Internet Access (ATIS-1000013)',
    dxOwner: 'dxOwner',
    dxAccess: 'dxAccess',
    bufferCC: false,
    cellTowerLocation: false,
    cfGroup: { id: 'id2', name: 'CookCounty' },
    deliveryType: 'DSR',
    country: 'US',
    stateName: '',
    city: '',
    insideNat: false,
    type: 'T1IAS',
    tag: 'CF-ATIS-1000013',
    timeZone: 'America/Tijuana',
    hi2Interfaces: [...mockHi2INterfaces].reverse(),
    hi3Interfaces: [...mockHi3Interfaces].reverse(),
  },
];

export const mockGenericConnectionFunction:CollectionFunction = {
  id: '',
  dxOwner: 'dxOwner',
  dxAccess: 'dxAccess',
  name: '',
  bufferCC: false,
  cellTowerLocation: false,
  contact: {
    id: '',
    name: '',
  },
  cfGroup: { id: 'id1', name: 'CA-DOJBNE' },
  deliveryType: 'DSR',
  insideNat: false,
  type: 'GPRS',
  tag: 'CF-3GPP-33108',
  country: '',
  stateName: '',
  city: '',
  timeZone: '',
  hi2Interfaces: [],
  hi3Interfaces: [],
}

export const mockNetworkTopologyCfInterfacesByType = {
  GPRS: {
    hi2Interfaces: true,
    hi3Interfaces: true,
  },
  ETSIIP: {
    hi2Interfaces: true,
    hi3Interfaces: true,
  },
  TIA1066: {
    hi2Interfaces: true,
    hi3Interfaces: true,
  },
  'T1.678': {
    hi2Interfaces: true,
    hi3Interfaces: true,
  },
  CALEA: {
    hi2Interfaces: true,
    hi3Interfaces: false,
  },
  TIA1072: {
    hi2Interfaces: true,
    hi3Interfaces: true,
  },
  T1IAS: {
    hi2Interfaces: false,
    hi3Interfaces: true,
  },
}
